module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epslf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("’Tis writ, “In the beginning was the Word!”")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("I pause, perplex’d! Who now will help afford?")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("I cannot the mere Word so highly prize;")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("I must translate it otherwise")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v(".  .  .  .  .  .  .  .  .  .  .  .  .  .  .  .")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("The spirit aids! from anxious scruples freed,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("I write, “In the beginning was the Deed!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("GOETHE")]), _vm._v(", "), _c('i', [_vm._v("Faust")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("“When I use a word,” Humpty Dumpty said, in a rather scornful tone, “it means just what I choose it to mean—neither more nor less.” “The question is,” said Alice, “whether you can make words mean so many different things.” “The question is,” said Humpty Dumpty, “which is to be master—that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LEWIS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CARROLL")]), _vm._v(", "), _c('i', [_vm._v("Through the Looking Glass")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0a4eb28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kuklick-0006.vue
// module id = 69
// module chunks = 0